
import React, { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { DataGrid, GridColumnMenu } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { City, State } from "country-state-city"; // 🧭 import both

import css from "../../css/admin/users-page.module.css";
import Loader from "../../components/common/Loader";
import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
import SecCard from "../../components/common/SecCard";
import BackButton from "../../components/common/BackButton";

const AllCities = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedState, setSelectedState] = useState("UP"); // default example: Uttar Pradesh
    const [allStates, setAllStates] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();
    const isReadOnly = hasReadOnlyAccess();

    useEffect(() => {
        try {
            const states = State.getStatesOfCountry("IN");
            setAllStates(states);
        } catch (error) {
            toast.error("Failed to load states");
        }
    }, []);

    useEffect(() => {
        async function getCities() {
            try {
                setIsLoading(true);
                const allCities = City.getCitiesOfState("IN", selectedState); // get by state ISO code

                const formatted = allCities.map((city, idx) => ({
                    id: idx + 1,
                    name: city.name,
                    stateCode: city.stateCode,
                    countryCode: city.countryCode,
                    latitude: city.latitude,
                    longitude: city.longitude,
                }));

                setCities(formatted);
            } catch (error) {
                toast.error("Failed to load city data");
            } finally {
                setIsLoading(false);
            }
        }

        if (selectedState) {
            getCities();
        }
    }, [selectedState]);

    const filteredCities = cities.filter((city) =>
        city.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "name", headerName: "City Name", width: 300 },
        { field: "stateCode", headerName: "State Code", width: 150 },
        { field: "countryCode", headerName: "Country Code", width: 150 },
        { field: "latitude", headerName: "Latitude", width: 150 },
        { field: "longitude", headerName: "Longitude", width: 150 },
    ];

    function CustomColumnMenu(props) {
        return (
            <GridColumnMenu
                {...props}
                slotProps={{
                    columnMenuUserItem: {
                        displayOrder: 15,
                        myCustomValue: "Do custom action",
                        myCustomHandler: () => alert("Custom handler fired"),
                    },
                }}
            />
        );
    }

    return (
        <div className={css.outerDiv}>
            <div className={css.headerSection}>
                <div className={css.headerLeft}>
                    <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />
                </div>
            </div>

            {isReadOnly && (
                <div className={css.readOnlyAlert}>
                    <div className="alert alert-info" role="alert">
                        <strong>Read-Only Access:</strong> You can view city data but cannot
                        add, edit, or delete any records.
                    </div>
                </div>
            )}

            <div className="my-4">
                <SecCard>
                    <Row className="g-4">
                        <div
                            className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
                        >
                            <div className={css.serviceName}>Cities Data</div>

                            <div className={css.headerRight}>
                                {/* {!isReadOnly && (
                                    <div className={css.actionButtons}>
                                        <button
                                            className={css.addBtn}
                                            onClick={() => navigate(`/cities/insert`)}
                                        >
                                            <FontAwesomeIcon icon={faPlus} className={css.addIcon} />
                                            Add City
                                        </button>
                                    </div>
                                )} */}
                            </div>
                        </div>
                    </Row>
                </SecCard>
            </div>

            <div className={css.filterBtns}>
                <div className={css.searchInputs}>
                    <div
                        className="d-flex"
                        style={{
                            position: "relative",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {/* 🔍 Search input */}
                        <div style={{ position: "relative", flex: 1, marginRight: "10px" }}>
                            <input
                                type="text"
                                value={searchQuery}
                                placeholder="Search from city list"
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className={css.searchInput}
                            />
                            <FontAwesomeIcon
                                icon={faMagnifyingGlass}
                                style={{ color: "black", position: "absolute", right: "10px", top: "10px" }}
                            />
                        </div>

                        {/* 🏙️ State selector */}
                        <select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            className={css.selectInput}
                            style={{
                                padding: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                            }}
                        >
                            <option value="">Select State</option>
                            {allStates.map((s) => (
                                <option key={s.isoCode} value={s.isoCode}>
                                    {s.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <Loader />
            ) : (
                <div>
                    <DataGrid
                        rows={filteredCities}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        slots={{ columnMenu: CustomColumnMenu }}
                    />
                </div>
            )}
        </div>
    );
};

export default AllCities;
